<div class="game-score__container" *transloco="let t; prefix: 'pages.game-component'">
    <app-nav-button *ngIf="themeService.isClosable()" icon="close" (clickEvent)="onCloseClicked()" class="game-score__back-button" />
    <div class="game-score__content" *ngIf="gameInterfaceState !== GameInterfaceState.GameStarted">
        <div class="game-score__title">
            <app-game-title [wordmarkUrl]="themeService.wordmarkUrl(gameId)" [title]="gameName ?? ''"></app-game-title>
        </div>
    </div>
    <div class="game-score__content" *ngIf="gameInterfaceState === GameInterfaceState.GameStarted">
        
        <!-- Tournaments countdown -->
        <div class="game-score__title" *ngIf="formattedTournamentCountdown">
            <span class="game-score__event-timer" [ngStyle]="eventTimerStyles | theme">
                {{ t('countdown-end-within') }}
            </span>
            <span class="game-score__event-countdown" [ngStyle]="eventCountdownStyles | theme">
                {{ formattedTournamentCountdown }}
            </span>
        </div>

        <!-- Opponent -->
        <div class="game-score__title" [ngClass]="{ 'cursor': opponentId }">
            <div role="button" class="player-name-icon" tabindex="0" (keydown.enter)="onOpponentClicked()"
                (keydown.space)="onOpponentClicked()" (click)="onOpponentClicked()">
                <span class="versus" [ngStyle]="versusStyles | theme"> vs </span>
                <span [ngClass]="{ 'opponent-nick': opponentId }" [ngStyle]="opponentStyles | theme">
                    {{ opponent }}
                </span>
                <app-profile-button *ngIf="themeService.hasProfileIconButton()" (clickEvent)="onOpponentClicked()"/>
            </div>
        </div>

        <div class="game-score__pill-content">
            <div class="game-pill" [ngStyle]="currencyPillStyles | theme">
                <span>{{ reward  || translocoService.translate('pages.game-component.practice') }}</span>
                <app-currency-icon *ngIf="currencyIcon && reward" [icon]="currencyIcon" sizeCss="--icon-medium"
                    class="currency-icon"></app-currency-icon>

                <app-bounty-pill  *ngIf="bountyAmountUSD" class="bounty-amount" size="small" [amount]="bountyAmountUSD"/>
            </div>
            <div *ngIf="score" class="game-pill" [ngStyle]="scorePillStyles | theme">
                {{ score }}
            </div>
            <div class="game-pill" [ngStyle]="scorePillStyles | theme">
                <span class="game-score__stack">
                    <!-- Ghost span to reserve space -->
                    <span *ngIf="countdown" class="game-score__ghost" aria-hidden="true">
                        {{ countdown | timeFormatGhost }}
                    </span>

                    <!-- Actual countdown display -->
                    <span *ngIf="countdown" class="game-score__visible" [ngClass]="{ 'game-score__danger': countdown < 60 }">
                        {{ countdown | timeFormat }}
                    </span>
                    <span *ngIf="isEnded()">{{ t('countdown-ended') }}</span>
                </span>
            </div>
        </div>
    </div>
</div>